<template>
  <div>
    <v-row class="mb-5">
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card class="filtros" @click="filtrar('')">
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ total }}
              </h2>
              <span>Total</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg primary--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="primary"
              >
                {{ icons.mdiAccountOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card class="filtros" @click="filtrar('false')">
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ inativos }}
              </h2>
              <span>Inativos</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg primary--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="primary"
              >
                {{ icons.mdiAccountMultipleMinusOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card class="filtros" @click="filtrar('true')">
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ ativos }}
              </h2>
              <span>Ativos</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg success--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="success"
              >
                {{ icons.mdiAccountCheckOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mdiAccountCheckOutline, mdiAccountOutline, mdiAccountPlusOutline, mdiAccountRemoveOutline, mdiAccountMultipleMinusOutline,
} from '@mdi/js'

export default {
  props: {
    total: {
      type: Number,
      default: 0,
    },
    ativos: {
      type: Number,
      default: 0,
    },
    inativos: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    filtrar(item){
      this.$emit('alterarFiltro', item)
    }
  },

  setup() {
    return {
      icons: {
        mdiAccountPlusOutline,
        mdiAccountCheckOutline,
        mdiAccountRemoveOutline,
        mdiAccountOutline,
        mdiAccountMultipleMinusOutline,
      },
    }
  },
}
</script>

<style>
  .filtros{
    cursor: pointer;
  }
  .filtros:hover{
    background-color: rgba(240, 248, 255, 0.094);
  }
</style>
